import { boolean, mixed, object, string } from "yup";
import { ChartOfAccountTypeEnum } from "@/features/chart-of-accounts";
import { StatusEnum } from "../../shared";

export const COA_TYPES = [
  ChartOfAccountTypeEnum.EXPENSES,
  ChartOfAccountTypeEnum.OTHER_EXPENSES,
];

export const DEFAULT_VALUES = {
  name: "",
  status: StatusEnum.ACTIVE,
  chartOfAccount: null,
};

export const VALIDATION_SCHEMA = object().shape({
  name: string().required("Harus diisi"),
  status: boolean().required("Harus diisi"),
  chartOfAccount: mixed().required("Harus diisi"),
});
